import moment from 'moment'

// export function delocalhost(url) {
//   if (url) {
//     //return url.replace('localhost', url)
//     const suffix = new URL(url).pathname
//     return process.env.VUE_APP_PARSE_SERVER_URL.slice(0, -4) + suffix
//   }
// }

export function getlFormatDate(date, formattingLocale) {
  moment.locale(formattingLocale)
  var localeData = moment.localeData()
  var dateFormatLocale = localeData.longDateFormat('ll')
  const dateString = moment(date).format(dateFormatLocale)
  return dateString
}

/* recursive function  max 20 elements inside */
export function checkIfTargetFromClass(target, className, rec = 0) {
  if (rec > 19) {
    // do not make recursive calls too big
    return false
  }
  if (target != null) {
    try {
      if (target.className && typeof target.className === 'string' && target.className.includes(className)) {
        return true
      } else {
        return checkIfTargetFromClass(target.parentElement, className, ++rec)
      }
    } catch (e) {}
  } else {
    return false
  }
}

/* recursive function  max 20 elements inside */
export function getAncestorOfClass(target, className, rec = 0) {
  if (rec > 19) {
    // do not make recursive calls too big
    return false
  }
  if (target != null) {
    try {
      if (target.className && typeof target.className === 'string' && target.className.includes(className)) {
        return target
      } else {
        return checkIfTargetFromClass(target.parentElement, className, ++rec)
      }
    } catch (e) {}
  } else {
    return false
  }
}

export function clearTextSelection() {
  if (window.getSelection) {
    if (window.getSelection().empty) {
      // Chrome
      window.getSelection().empty()
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      window.getSelection().removeAllRanges()
    }
  } else if (document.selection) {
    // IE?
    document.selection.empty()
  }
}
